module.exports = __webpack_public_path__ + "img/unique-1-tab.77b1d8d.webp";